/** Runtime configuration sourced from Vite env (see .env.example). */
export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api/v1',
  errorSinkDsn: import.meta.env.VITE_ERROR_SINK_DSN ?? '',
  // Public website origin — where draft Preview renders the page from a mint-once token.
  // No trailing slash. Defaults to the local dev site.
  siteBaseUrl: (import.meta.env.VITE_SITE_BASE_URL ?? 'http://localhost:3000').replace(/\/$/, ''),
  // Whether the page editor exposes the Sections (block builder) tab. The current
  // website is copy-driven and does not render page sections, so this is hidden by default.
  // Set VITE_SHOW_PAGE_SECTIONS=true to re-enable once the site consumes sections.
  showPageSections: import.meta.env.VITE_SHOW_PAGE_SECTIONS === 'true',
} as const;

/** Refresh proactively this many ms before access-token expiry (plan §4.2). */
export const REFRESH_LEAD_MS = 60_000;

/** Per-list pagination cap (spec §5.2). */
export const MAX_PER_PAGE = 100;
export const DEFAULT_PER_PAGE = 20;

/** Media upload cap (spec §10). */
export const MEDIA_MAX_BYTES = 32 * 1024 * 1024;

/** Bulk action id cap (spec §9.3 / gap 16). */
export const BULK_MAX_IDS = 100;

/** CSV export row cap; server sets X-Export-Truncated when hit (gap 15). */
export const EXPORT_ROW_CAP = 5000;
